import React, { useState, useEffect } from "react";
import Table from "../../../parts/table/Table";

const HasilKuisDetailPilihanGanda = (props) => {
  const [data, setdata] = useState(props.dataSoal ?? []);

  let jumlah = Array.from({ length: props.jumlahSoal }, (x, i) => i);
  let colJawaban = jumlah.map((val, idx) => {
    return {
      Header: val + 1,
      id: val,
      accessor: "judul",
      Cell: ({ row }) => {
        return <p>{row.original.jawaban[idx]}</p>;
      },
    };
  });
  let staticCol = [
    {
      Header: "No",
      accessor: "id",
      Cell: ({row}) => {
        return(
          <p>{row.index + 1}</p>
        )
      }
    },
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "Nama User",
      accessor: "nama",
    },
  ];
  let columns = staticCol.concat(colJawaban);

  useEffect(() => {
    // pushSkala1();
  }, []);

  return (
    <div
      className="w-full flex flex-col py-10 dark:text-white"
      style={{ minHeight: "100vh" }}
    >
      {columns.length === 3 + props.jumlahSoal ? (
        <Table columns={columns} data={data} />
      ) : null}
    </div>
  );
};

export default HasilKuisDetailPilihanGanda;
